import React, {FC, useMemo} from 'react'
import {ID} from '../../../../../../../_metronic/helpers'
import {useSiteListView} from '../../core/SiteListViewProvider'

type Props = {
  id: ID
}

export const SiteSelectionCell: FC<Props> = ({id}) => {
  const {selected, onSelect} = useSiteListView()
  const isSelected = useMemo(() => selected.includes(id), [id, selected])

  return (
    <div className='form-check form-check-custom form-check-solid'>
      <input
        className='form-check-input'
        type='checkbox'
        data-kt-check={isSelected}
        data-kt-check-target='#kt_table_users .form-check-input'
        checked={isSelected}
        onChange={() => onSelect(id)}
      />
    </div>
  )
}
